import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography, Toolbar, Hidden  } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import PropertyMenu from './PropertyMenu' // メニュー

import { useDispatch, useSelector } from 'react-redux';
import {
    setDebt,
    clearDebt,
} from '../stores/debt'

import Explanation from './Explanation'
import MenuList from './MenuList' // メニュー
import GuideHalf from './GuideHalf' // ガイド

import FlowTitle from './FlowTitle' // フロータイトル
import FlowItem from './FlowItem' // フローアイテム
import FlowArrow from './FlowArrow' // フローアロー

import PageExplanation from './PageExplanation' // ページ説明

import TargetPerson from './TargetPerson' // 相続人
import InheritanceBequest from './InheritanceBequest' // 相続・遺贈

const useStyles = makeStyles((theme) => ({
    head: {
        backgroundColor: '#3f51b5',
        color: '#fff'
    },
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    },
    listWrap: {
        width: '100%',
        marginTop: '10px'
    },
    center: {
        textAlign: 'center'
    },
    cellButton: {
        width: '15%'
    }
}));

// 債務
function Debt(){
    const dispatch = useDispatch();

    const igonFlag = useSelector(state => state.igon.igonFlag);
    const debt = useSelector(state => state.debt.debt);
    const heiress = useSelector(state => state.heiress.heiress);

    const [error, setError] = useState(null);

    const handleDebt = (event) => {
        const type = document.getElementById('debt_type').value;
        const debtor = document.getElementById('debt_debtor').value;
        const amountMoney = document.getElementById('debt_amount_money').value;

        if(type == ''){
            checkType(true);
            typeHelper('債務の種類は必ずご入力くさだい。');
            setError('エラーが発生しました。債務の種類は必ずご入力くさだい。');
            return;
        }else if(debtor == ''){
            checkDebtor(true);
            debtorHelper('債務者は必ずご入力くさだい。');
            setError('エラーが発生しました。債務者は必ずご入力くさだい。');
            return;
        }else if(amountMoney == ''){
            checkAmountMoney(true);
            amountMoneyHelper('金額は必ずご入力くさだい。');
            setError('エラーが発生しました。金額は必ずご入力くさだい。');
            return;
        }

        let targetPerson = null;
        let inheritanceBequest = null;

        if(igonFlag){
            targetPerson = document.getElementsByName('debt_target_person')[0].value;
            inheritanceBequest = document.getElementsByName('debt_inheritance_bequest')[0].value;
            if(igonFlag && targetPerson == ''){
                checkTargetPerson(true);
                targetPersonHelper('取得対象者は必ずご入力くさだい。');
                setError('エラーが発生しました。取得対象者は必ずご入力くさだい。');
                return;
            }else if(igonFlag && inheritanceBequest == ''){
                checkInheritanceBequest(true);
                inheritanceBequestHelper('相続・遺贈は必ずご入力くさだい。');
                setError('エラーが発生しました。相続・遺贈は必ずご入力くさだい。');
                return;
            }

            targetPerson = heiress[targetPerson].name;
        }

        document.getElementById('debt_type').value = '';
        document.getElementById('debt_debtor').value = '';
        document.getElementById('debt_amount_money').value = '';

        setTypeValue(null);
        setDebtorValue(null);
        setAmountMoneyValue(null);

        if(igonFlag){
            setTargetPersonValue(null);
            setInheritanceBequestValue(null);
        }

        const debt = {
            type: type,
            debtor: debtor,
            amountMoney: amountMoney,
            targetPerson: targetPerson,
            inheritanceBequest: inheritanceBequest,
        };

        setError('登録しました。');

        dispatch(setDebt(debt));
    }

    // 編集
    const [typeValue, setTypeValue] = useState(null);
    const [debtorValue, setDebtorValue] = useState(null);
    const [amountMoneyValue, setAmountMoneyValue] = useState(null);
    const [targetPersonValue, setTargetPersonValue] = useState(null);
    const [inheritanceBequestValue, setInheritanceBequestValue] = useState(null);

    const handleDebtEdit = (index, event) => {
        const debtEdit = debt[index];

        setTypeValue(debtEdit.type);
        setDebtorValue(debtEdit.debtor);
        setAmountMoneyValue(debtEdit.amountMoney);
        setTargetPersonValue(debtEdit.targetPerson);
        setInheritanceBequestValue(debtEdit.inheritanceBequest);

        dispatch(clearDebt(index))
    }

    // 削除
    const handleDebtDelete = (index, event) => {
        dispatch(clearDebt(index))
        setOpen(false);
    }

    const [typeHelperText, typeHelper] = useState('必須');
    const [debtorHelperText, debtorHelper] = useState('必須');
    const [amountMoneyHelperText, amountMoneyHelper] = useState('必須');
    const [targetPersonHelperText, targetPersonHelper] = useState('必須');
    const [inheritanceBequestHelperText, inheritanceBequestHelper] = useState('必須');

    const [typeValidate, checkType] = useState(false);
    const handleType = (event) => {
        if(event.target.value){
            checkType(false);
            typeHelper('必須');
            setTypeValue(event.target.value);
        }else{
            checkType(true);
            typeHelper('種別は必ずご入力くさだい。');
            setTypeValue(null);
        }
    }

    const [debtorValidate, checkDebtor] = useState(false);
    const handleDebtor = (event) => {
        if(event.target.value){
            checkDebtor(false);
            debtorHelper('必須');
            setDebtorValue(event.target.value);
        }else{
            checkDebtor(true);
            debtorHelper('債務者は必ずご入力くさだい。');
            setDebtorValue(null);
        }
    }

    const [amountMoneyValidate, checkAmountMoney] = useState(false);
    const handleAmountMoney = (event) => {
        if(event.target.value){
            checkAmountMoney(false);
            amountMoneyHelper('必須');
            setAmountMoneyValue(event.target.value);
        }else{
            checkAmountMoney(true);
            amountMoneyHelper('金額は必ずご入力くさだい。');
            setAmountMoneyValue(null);
        }
    }

    const [targetPersonValidate, checkTargetPerson] = useState(false);
    const handleTargetPerson = (event) => {
        if(event.target.value){
            checkTargetPerson(false);
            targetPersonHelper('必須');
            setTargetPersonValue(event.target.value);
        }else{
            checkTargetPerson(true);
            targetPersonHelper('取得対象者は必ずご入力くさだい。');
            setTargetPersonValue(null);
        }
    }

    const [inheritanceBequestValidate, checkInheritanceBequest] = useState(false);
    const handleInheritanceBequest = (event) => {
        if(event.target.value){
            checkInheritanceBequest(false);
            inheritanceBequestHelper('必須');
            setInheritanceBequestValue(event.target.value);
        }else{
            checkInheritanceBequest(true);
            inheritanceBequestHelper('相続・遺贈は必ずご入力くさだい。');
            setInheritanceBequestValue(null);
        }
    }

    const [deleteTargetIndex, deleteTarget] = useState(null);

    const [open, setOpen] = useState(false);

    const handleDialogOpen = (index) => {
        setOpen(true);
        deleteTarget(index);
    }

    const handleDialogClose = () => {
        setOpen(false);
    }

    const classes = useStyles();

    return(
        <Container>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <PageExplanation pageName="債務" firstItemName="債務の種類" igonFlag={igonFlag}/>

                    <MenuList pageName="債務" />

                    <TextField
                        id="debt_type"
                        name="debt_type"
                        label="債務の種類(借入金・買掛金)"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="債務の種類をご入力ください。"
                        helperText={typeHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleType}
                        onChange={handleType}
                        error={typeValidate}
                        value={typeValue}
                    />
                    <TextField
                        id="debt_debtor"
                        name="debt_debtor"
                        label="債権者"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="債権者をご入力ください。"
                        helperText={debtorHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleDebtor}
                        onChange={handleDebtor}
                        error={debtorValidate}
                        value={debtorValue}
                    />
                    <TextField
                        id="debt_amount_money"
                        name="debt_amount_money"
                        label="金額"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="金額をご入力ください。"
                        helperText={amountMoneyHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleAmountMoney}
                        onChange={handleAmountMoney}
                        error={amountMoneyValidate}
                        value={amountMoneyValue}
                    />
                    <TargetPerson targetPersonId="debt_target_person" targetPersonName="debt_target_person"/>
                    <InheritanceBequest inheritanceBequestId="debt_inheritance_bequest" inheritanceBequestName="debt_inheritance_bequest"/>

                    <Explanation/>

                    <Paper className={classes.listWrap}>
                        <Toolbar>
                            <Typography variant="h6">今入力されている債務の一覧</Typography>
                        </Toolbar>
                            {
                                (()=>{
                                    if(debt !== undefined && debt.length){
                                        return (
                                            <>
                                            <Hidden smDown>
                                            <TableContainer component={Paper} className={classes.list}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.head}>債務の種類</TableCell>
                                                            <TableCell className={classes.head}>債権者</TableCell>
                                                            <TableCell className={classes.head}>金額</TableCell>
                                                            <TableCell className={classes.head}>&nbsp;</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {debt.map((row, index) => {
                                                        return (
                                                            <TableRow hover>
                                                                <TableCell>{row.type}</TableCell>
                                                                <TableCell>{row.debtor}</TableCell>
                                                                <TableCell>{row.amountMoney}</TableCell>
                                                                <TableCell>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="default"
                                                                        style={{ margin: 8 }}
                                                                        onClick={(event) => { handleDebtEdit(index, event) }}
                                                                        startIcon={<EditIcon/>}
                                                                        className={classes.operating}
                                                                    >
                                                                    編集
                                                                    </Button>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="default"
                                                                        style={{ margin: 8 }}
                                                                        onClick={(event) => { handleDialogOpen(index) }}
                                                                        startIcon={<DeleteIcon/>}
                                                                        className={classes.operating}
                                                                    >
                                                                    削除
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            </Hidden>

                                            <Hidden mdUp>
                                                <TableContainer component={Paper} className={classes.list}>
                                                    <Table size="small">
                                                        {debt.map((row, index) => {
                                                            return (
                                                                <>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell className={classes.head} colspan={2}>財産番号&nbsp;債務({index+1})</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                <TableRow hover>
                                                                    <TableCell>債務の種類</TableCell>
                                                                    <TableCell>{row.type}</TableCell>
                                                                </TableRow>
                                                                <TableRow hover>
                                                                    <TableCell>債務者</TableCell>
                                                                    <TableCell>{row.debtor}</TableCell>
                                                                </TableRow>
                                                                <TableRow hover>
                                                                    <TableCell>金額</TableCell>
                                                                    <TableCell>{row.amountMoney}</TableCell>
                                                                </TableRow>
                                                                <TableRow hover>
                                                                    <TableCell colspan={2} className={classes.center}>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="default"
                                                                            style={{ margin: 8 }}
                                                                            onClick={(event) => { handleDebtEdit(index, event) }}
                                                                            startIcon={<EditIcon/>}
                                                                            className={classes.operating}
                                                                        >
                                                                        編集
                                                                        </Button>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="default"
                                                                            style={{ margin: 8 }}
                                                                            onClick={(event) => { handleDialogOpen(index) }}
                                                                            startIcon={<DeleteIcon/>}
                                                                            className={classes.operating}
                                                                        >
                                                                        削除
                                                                        </Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                                </TableBody>
                                                                </>
                                                            );
                                                        })}
                                                    </Table>
                                                </TableContainer>
                                            </Hidden>
                                            </>
                                        );
                                    }else{
                                        return (
                                            <>
                                            <Hidden smDown>
                                            <TableContainer component={Paper} className={classes.list}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.head}>債務の種類</TableCell>
                                                            <TableCell className={classes.head}>債務者</TableCell>
                                                            <TableCell className={classes.head}>金額</TableCell>
                                                            <TableCell className={classes.head}>&nbsp;</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow hover>
                                                            <TableCell colSpan={4}><Typography>入力している債務の情報はありません</Typography></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            </Hidden>

                                            <Hidden mdUp>
                                                <TableContainer component={Paper} className={classes.list}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className={classes.head} colspan={2}>財産番号</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow hover>
                                                                <TableCell>債務の種類</TableCell>
                                                                <TableCell rowspan={4}>入力している債務の<br/>情報はありません</TableCell>
                                                            </TableRow>
                                                            <TableRow hover>
                                                                <TableCell>債務者</TableCell>
                                                            </TableRow>
                                                            <TableRow hover>
                                                                <TableCell>金額</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Hidden>
                                            </>
                                        )
                                    }
                                })()
                            }
                    </Paper>

                    <Dialog
                        open={open}
                        onClose={handleDialogClose}
                    >
                        <DialogTitle>{"削除確認"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                削除します。よろしいですか?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogClose} color="dafalut">
                                いいえ
                            </Button>
                            <Button onClick={() => { handleDebtDelete(deleteTargetIndex) }} color="secondary">
                                はい
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <PropertyMenu execute={handleDebt} message={error}/>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <FlowTitle title="財産目録の作成の流れをご説明します。【債務】" />
                    <FlowItem image="img/icon_list.png" contents="①債務を入力します。<br>必要項目を入力します。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_person.png" contents="②この財産の取得対象者を入力します。<br>取得対象者の姓名を正確に入力します。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_check.png" contents="③相続・遺贈を入力します。<br>相続とは、財産を法定相続人が引き継ぐことです。法定相続人以外の者に、「相続させる」ことはできません。<br>遺贈とは、遺言によって、無償で財産を譲与することです。<br>法定相続人には、遺贈ではなく「相続させる」方が、課税や手続などの面で有利な場合が多いと考えられています。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_list.png" contents="④他の財産を入力する。<br>「メニューから保有する財産を選ぶ」をクリックし、メニューの中<br>から入力したい財産を選んで入力します。" />
                    <GuideHalf pageName="債務"/>
                </Grid>
            </Grid>

        </Container>
    );
}

export default Debt
